import { get, post } from '@/service/request';

const url = 'api/external/';

// 取得銀行的總行下拉選單
export function getBankInfo(aplCatl) {
    return get(`${url}${aplCatl}/bankInfo`);
}

// 取得銀行的分行下拉選單
export function postBranchBankInfo(aplCatl, data) {
    return post(`${url}${aplCatl}/branchBankInfo`, { bankNo: data });
}

// 保戶進入A3A4A5前，取得目前資訊
export function getInfo(aplCatl) {
    return get(`${url}${aplCatl}/info`);
}

// 送出此次申請內容
export function postSubmit(aplCatl, data) {
    return post(`${url}${aplCatl}/submit`, data);
}
